export type DropdownOption = {
    value: string;
    displayValue: string;
};

const MONTH_LABELS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

export const getCurrentMonthInput = () => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${now.getFullYear()}-${month}`;
};

export const getLastTwelveMonthsOptions = (): DropdownOption[] => {
    const options: DropdownOption[] = [];
    const date = new Date();
    date.setDate(1);

    for (let index = 0; index < 12; index += 1) {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        options.push({
            value: `${year}-${month}`,
            displayValue: `${MONTH_LABELS[date.getMonth()]} ${year}`,
        });
        date.setMonth(date.getMonth() - 1);
    }

    return options;
};

export const AGGREGATE_BY_OPTIONS = [
    { value: 'day', displayValue: 'Day' },
    { value: 'month', displayValue: 'Month' },
];

export type TxnAggLevel = 'day' | 'month';

/** First moment and last moment of the calendar month for `YYYY-MM`. */
export const getMonthDateRange = (
    yyyyMm: string
): { start: Date; end: Date } => {
    const [y, m] = yyyyMm.split('-').map((part) => parseInt(part, 10));
    const start = new Date(y, m - 1, 1, 0, 0, 0, 0);
    const end = new Date(y, m, 0, 23, 59, 59, 999);
    return { start, end };
};
